module.exports = __webpack_public_path__ + "static/img/10003 (1).b1a70d3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10003 (1).webp
// module id = QELv
// module chunks = 14